/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.dpg.devex.agents.rpc.WorkspacesRpc
 */

/* @bend-expect import-missing-runtime-dep */
import { useMemo } from 'react';
import {
  useQuery,
  useLazyQuery,
  useSuspenseQuery,
  QueryHookOptions,
  LazyQueryHookOptions,
  SuspenseQueryHookOptions,
  LazyQueryResultTuple,
  QueryResult,
  UseSuspenseQueryResult,
  useMutation,
  MutationHookOptions,
  MutationTuple,
} from 'data-fetching-client';
import * as References from './WorkspacesRpc';
import * as Queries from './WorkspacesRpc.dfc.new';
import type { AdditionalContextArgs } from './WorkspacesRpc.dfc.new';

type OverrideData<TTuple extends [any, any], TNewData> = [
  TTuple[0],
  Omit<TTuple[1], 'data'> & { data?: TNewData },
];

type MutationTupleOverride<Response, Request, DataOverride> = OverrideData<
  MutationTuple<Response, Request>,
  DataOverride
>;
type LazyQueryResultTupleOverride<
  Response,
  Request extends Record<string, any>,
  DataOverride,
> = OverrideData<LazyQueryResultTuple<Response, Request>, DataOverride>;

type UseCreateMutationReturn<T extends boolean> = MutationTupleOverride<
  Record<'result', References.CreateResponseType>,
  References.CreateRequestType,
  T extends true
    ? Record<'create', References.CreateResponseType>
    : References.CreateResponseType
>;

export function useCreateMutation<T extends boolean = false>(
  options?: MutationHookOptions<
    Record<'result', References.CreateResponseType>,
    References.CreateRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseCreateMutationReturn<T> {
  const [getter, { data, ...rest }] = useMutation(
    Queries.CREATE_MUTATION,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            create: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return [
      getter,
      { data: legacyFormatData, ...rest },
    ] as UseCreateMutationReturn<T>;
  }
  return [
    getter,
    { data: data?.result, ...rest },
  ] as UseCreateMutationReturn<T>;
}

type UseStartMutationReturn<T extends boolean> = MutationTupleOverride<
  Record<'result', References.StartResponseType>,
  References.StartRequestType,
  T extends true
    ? Record<'start', References.StartResponseType>
    : References.StartResponseType
>;

export function useStartMutation<T extends boolean = false>(
  options?: MutationHookOptions<
    Record<'result', References.StartResponseType>,
    References.StartRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseStartMutationReturn<T> {
  const [getter, { data, ...rest }] = useMutation(
    Queries.START_MUTATION,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            start: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return [
      getter,
      { data: legacyFormatData, ...rest },
    ] as UseStartMutationReturn<T>;
  }
  return [getter, { data: data?.result, ...rest }] as UseStartMutationReturn<T>;
}

type UseForkMutationReturn<T extends boolean> = MutationTupleOverride<
  Record<'result', References.ForkResponseType>,
  References.ForkRequestType,
  T extends true
    ? Record<'fork', References.ForkResponseType>
    : References.ForkResponseType
>;

export function useForkMutation<T extends boolean = false>(
  options?: MutationHookOptions<
    Record<'result', References.ForkResponseType>,
    References.ForkRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseForkMutationReturn<T> {
  const [getter, { data, ...rest }] = useMutation(
    Queries.FORK_MUTATION,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            fork: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return [
      getter,
      { data: legacyFormatData, ...rest },
    ] as UseForkMutationReturn<T>;
  }
  return [getter, { data: data?.result, ...rest }] as UseForkMutationReturn<T>;
}

type UseRestoreMutationReturn<T extends boolean> = MutationTupleOverride<
  Record<'result', References.RestoreResponseType>,
  References.RestoreRequestType,
  T extends true
    ? Record<'restore', References.RestoreResponseType>
    : References.RestoreResponseType
>;

export function useRestoreMutation<T extends boolean = false>(
  options?: MutationHookOptions<
    Record<'result', References.RestoreResponseType>,
    References.RestoreRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseRestoreMutationReturn<T> {
  const [getter, { data, ...rest }] = useMutation(
    Queries.RESTORE_MUTATION,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            restore: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return [
      getter,
      { data: legacyFormatData, ...rest },
    ] as UseRestoreMutationReturn<T>;
  }
  return [
    getter,
    { data: data?.result, ...rest },
  ] as UseRestoreMutationReturn<T>;
}

type UseCloneMutationReturn<T extends boolean> = MutationTupleOverride<
  Record<'result', References.CloneResponseType>,
  References.CloneRequestType,
  T extends true
    ? Record<'clone', References.CloneResponseType>
    : References.CloneResponseType
>;

export function useCloneMutation<T extends boolean = false>(
  options?: MutationHookOptions<
    Record<'result', References.CloneResponseType>,
    References.CloneRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseCloneMutationReturn<T> {
  const [getter, { data, ...rest }] = useMutation(
    Queries.CLONE_MUTATION,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            clone: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return [
      getter,
      { data: legacyFormatData, ...rest },
    ] as UseCloneMutationReturn<T>;
  }
  return [getter, { data: data?.result, ...rest }] as UseCloneMutationReturn<T>;
}

type UseGetByIdQueryReturn<T extends boolean> = Omit<
  QueryResult<
    Record<'result', References.GetByIdResponseType>,
    References.GetByIdRequestType
  >,
  'data'
> & {
  data:
    | (T extends true
        ? Record<'getById', References.GetByIdResponseType>
        : References.GetByIdResponseType)
    | undefined;
};

export function useGetByIdQuery<T extends boolean = false>(
  options?: QueryHookOptions<
    Record<'result', References.GetByIdResponseType>,
    References.GetByIdRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetByIdQueryReturn<T> {
  const { data, ...rest } = useQuery(Queries.GET_BY_ID_QUERY, options);

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            getById: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return { data: legacyFormatData, ...rest } as UseGetByIdQueryReturn<T>;
  }
  return { data: data?.result, ...rest } as UseGetByIdQueryReturn<T>;
}

type UseGetByIdLazyQueryReturn<T extends boolean> =
  LazyQueryResultTupleOverride<
    Record<'result', References.GetByIdResponseType>,
    References.GetByIdRequestType,
    T extends true
      ? Record<'getById', References.GetByIdResponseType>
      : References.GetByIdResponseType
  >;

export function useGetByIdLazyQuery<T extends boolean = false>(
  options?: LazyQueryHookOptions<
    Record<'result', References.GetByIdResponseType>,
    References.GetByIdRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetByIdLazyQueryReturn<T> {
  const [getter, { data, ...rest }] = useLazyQuery(
    Queries.GET_BY_ID_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            getById: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return [
      getter,
      { data: legacyFormatData, ...rest },
    ] as UseGetByIdLazyQueryReturn<T>;
  }
  return [
    getter,
    { data: data?.result, ...rest },
  ] as UseGetByIdLazyQueryReturn<T>;
}

type UseGetByIdSuspenseQueryReturn<T extends boolean> = Omit<
  UseSuspenseQueryResult<
    Record<'result', References.GetByIdResponseType>,
    References.GetByIdRequestType
  >,
  'data'
> & {
  data: T extends true
    ? Record<'getById', References.GetByIdResponseType>
    : References.GetByIdResponseType;
};

export function useGetByIdSuspenseQuery<T extends boolean = false>(
  options?: SuspenseQueryHookOptions<
    Record<'result', References.GetByIdResponseType>,
    References.GetByIdRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetByIdSuspenseQueryReturn<T> {
  const { data, ...rest } = useSuspenseQuery(Queries.GET_BY_ID_QUERY, options);

  const legacyFormatData = useMemo(
    () =>
      options?.useLegacyFieldNameMode
        ? {
            getById: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseGetByIdSuspenseQueryReturn<T>;
  }
  return {
    data: data?.result,
    ...rest,
  } as UseGetByIdSuspenseQueryReturn<T>;
}

type UseGetComponentsQueryReturn<T extends boolean> = Omit<
  QueryResult<
    Record<'result', References.GetComponentsResponseType>,
    References.GetComponentsRequestType
  >,
  'data'
> & {
  data:
    | (T extends true
        ? Record<'getComponents', References.GetComponentsResponseType>
        : References.GetComponentsResponseType)
    | undefined;
};

export function useGetComponentsQuery<T extends boolean = false>(
  options?: QueryHookOptions<
    Record<'result', References.GetComponentsResponseType>,
    References.GetComponentsRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetComponentsQueryReturn<T> {
  const { data, ...rest } = useQuery(Queries.GET_COMPONENTS_QUERY, options);

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            getComponents: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseGetComponentsQueryReturn<T>;
  }
  return { data: data?.result, ...rest } as UseGetComponentsQueryReturn<T>;
}

type UseGetComponentsLazyQueryReturn<T extends boolean> =
  LazyQueryResultTupleOverride<
    Record<'result', References.GetComponentsResponseType>,
    References.GetComponentsRequestType,
    T extends true
      ? Record<'getComponents', References.GetComponentsResponseType>
      : References.GetComponentsResponseType
  >;

export function useGetComponentsLazyQuery<T extends boolean = false>(
  options?: LazyQueryHookOptions<
    Record<'result', References.GetComponentsResponseType>,
    References.GetComponentsRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetComponentsLazyQueryReturn<T> {
  const [getter, { data, ...rest }] = useLazyQuery(
    Queries.GET_COMPONENTS_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            getComponents: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return [
      getter,
      { data: legacyFormatData, ...rest },
    ] as UseGetComponentsLazyQueryReturn<T>;
  }
  return [
    getter,
    { data: data?.result, ...rest },
  ] as UseGetComponentsLazyQueryReturn<T>;
}

type UseGetComponentsSuspenseQueryReturn<T extends boolean> = Omit<
  UseSuspenseQueryResult<
    Record<'result', References.GetComponentsResponseType>,
    References.GetComponentsRequestType
  >,
  'data'
> & {
  data: T extends true
    ? Record<'getComponents', References.GetComponentsResponseType>
    : References.GetComponentsResponseType;
};

export function useGetComponentsSuspenseQuery<T extends boolean = false>(
  options?: SuspenseQueryHookOptions<
    Record<'result', References.GetComponentsResponseType>,
    References.GetComponentsRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetComponentsSuspenseQueryReturn<T> {
  const { data, ...rest } = useSuspenseQuery(
    Queries.GET_COMPONENTS_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      options?.useLegacyFieldNameMode
        ? {
            getComponents: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseGetComponentsSuspenseQueryReturn<T>;
  }
  return {
    data: data?.result,
    ...rest,
  } as UseGetComponentsSuspenseQueryReturn<T>;
}

type UseGetByProjectNameQueryReturn<T extends boolean> = Omit<
  QueryResult<
    Record<'result', References.GetByProjectNameResponseType>,
    References.GetByProjectNameRequestType
  >,
  'data'
> & {
  data:
    | (T extends true
        ? Record<'getByProjectName', References.GetByProjectNameResponseType>
        : References.GetByProjectNameResponseType)
    | undefined;
};

export function useGetByProjectNameQuery<T extends boolean = false>(
  options?: QueryHookOptions<
    Record<'result', References.GetByProjectNameResponseType>,
    References.GetByProjectNameRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetByProjectNameQueryReturn<T> {
  const { data, ...rest } = useQuery(
    Queries.GET_BY_PROJECT_NAME_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            getByProjectName: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseGetByProjectNameQueryReturn<T>;
  }
  return { data: data?.result, ...rest } as UseGetByProjectNameQueryReturn<T>;
}

type UseGetByProjectNameLazyQueryReturn<T extends boolean> =
  LazyQueryResultTupleOverride<
    Record<'result', References.GetByProjectNameResponseType>,
    References.GetByProjectNameRequestType,
    T extends true
      ? Record<'getByProjectName', References.GetByProjectNameResponseType>
      : References.GetByProjectNameResponseType
  >;

export function useGetByProjectNameLazyQuery<T extends boolean = false>(
  options?: LazyQueryHookOptions<
    Record<'result', References.GetByProjectNameResponseType>,
    References.GetByProjectNameRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetByProjectNameLazyQueryReturn<T> {
  const [getter, { data, ...rest }] = useLazyQuery(
    Queries.GET_BY_PROJECT_NAME_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            getByProjectName: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return [
      getter,
      { data: legacyFormatData, ...rest },
    ] as UseGetByProjectNameLazyQueryReturn<T>;
  }
  return [
    getter,
    { data: data?.result, ...rest },
  ] as UseGetByProjectNameLazyQueryReturn<T>;
}

type UseGetByProjectNameSuspenseQueryReturn<T extends boolean> = Omit<
  UseSuspenseQueryResult<
    Record<'result', References.GetByProjectNameResponseType>,
    References.GetByProjectNameRequestType
  >,
  'data'
> & {
  data: T extends true
    ? Record<'getByProjectName', References.GetByProjectNameResponseType>
    : References.GetByProjectNameResponseType;
};

export function useGetByProjectNameSuspenseQuery<T extends boolean = false>(
  options?: SuspenseQueryHookOptions<
    Record<'result', References.GetByProjectNameResponseType>,
    References.GetByProjectNameRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetByProjectNameSuspenseQueryReturn<T> {
  const { data, ...rest } = useSuspenseQuery(
    Queries.GET_BY_PROJECT_NAME_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      options?.useLegacyFieldNameMode
        ? {
            getByProjectName: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseGetByProjectNameSuspenseQueryReturn<T>;
  }
  return {
    data: data?.result,
    ...rest,
  } as UseGetByProjectNameSuspenseQueryReturn<T>;
}

type UseGetByConversationQueryReturn<T extends boolean> = Omit<
  QueryResult<
    Record<'result', References.GetByConversationResponseType>,
    References.GetByConversationRequestType
  >,
  'data'
> & {
  data:
    | (T extends true
        ? Record<'getByConversation', References.GetByConversationResponseType>
        : References.GetByConversationResponseType)
    | undefined;
};

export function useGetByConversationQuery<T extends boolean = false>(
  options?: QueryHookOptions<
    Record<'result', References.GetByConversationResponseType>,
    References.GetByConversationRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetByConversationQueryReturn<T> {
  const { data, ...rest } = useQuery(
    Queries.GET_BY_CONVERSATION_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            getByConversation: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseGetByConversationQueryReturn<T>;
  }
  return { data: data?.result, ...rest } as UseGetByConversationQueryReturn<T>;
}

type UseGetByConversationLazyQueryReturn<T extends boolean> =
  LazyQueryResultTupleOverride<
    Record<'result', References.GetByConversationResponseType>,
    References.GetByConversationRequestType,
    T extends true
      ? Record<'getByConversation', References.GetByConversationResponseType>
      : References.GetByConversationResponseType
  >;

export function useGetByConversationLazyQuery<T extends boolean = false>(
  options?: LazyQueryHookOptions<
    Record<'result', References.GetByConversationResponseType>,
    References.GetByConversationRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetByConversationLazyQueryReturn<T> {
  const [getter, { data, ...rest }] = useLazyQuery(
    Queries.GET_BY_CONVERSATION_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            getByConversation: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return [
      getter,
      { data: legacyFormatData, ...rest },
    ] as UseGetByConversationLazyQueryReturn<T>;
  }
  return [
    getter,
    { data: data?.result, ...rest },
  ] as UseGetByConversationLazyQueryReturn<T>;
}

type UseGetByConversationSuspenseQueryReturn<T extends boolean> = Omit<
  UseSuspenseQueryResult<
    Record<'result', References.GetByConversationResponseType>,
    References.GetByConversationRequestType
  >,
  'data'
> & {
  data: T extends true
    ? Record<'getByConversation', References.GetByConversationResponseType>
    : References.GetByConversationResponseType;
};

export function useGetByConversationSuspenseQuery<T extends boolean = false>(
  options?: SuspenseQueryHookOptions<
    Record<'result', References.GetByConversationResponseType>,
    References.GetByConversationRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetByConversationSuspenseQueryReturn<T> {
  const { data, ...rest } = useSuspenseQuery(
    Queries.GET_BY_CONVERSATION_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      options?.useLegacyFieldNameMode
        ? {
            getByConversation: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseGetByConversationSuspenseQueryReturn<T>;
  }
  return {
    data: data?.result,
    ...rest,
  } as UseGetByConversationSuspenseQueryReturn<T>;
}

type UseUpdateInfoMutationReturn<T extends boolean> = MutationTupleOverride<
  Record<'result', References.UpdateInfoResponseType>,
  References.UpdateInfoRequestType,
  T extends true
    ? Record<'updateInfo', References.UpdateInfoResponseType>
    : References.UpdateInfoResponseType
>;

export function useUpdateInfoMutation<T extends boolean = false>(
  options?: MutationHookOptions<
    Record<'result', References.UpdateInfoResponseType>,
    References.UpdateInfoRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseUpdateInfoMutationReturn<T> {
  const [getter, { data, ...rest }] = useMutation(
    Queries.UPDATE_INFO_MUTATION,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            updateInfo: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return [
      getter,
      { data: legacyFormatData, ...rest },
    ] as UseUpdateInfoMutationReturn<T>;
  }
  return [
    getter,
    { data: data?.result, ...rest },
  ] as UseUpdateInfoMutationReturn<T>;
}

type UseDeleteMutationReturn<T extends boolean> = MutationTupleOverride<
  Record<'result', References.DeleteResponseType>,
  References.DeleteRequestType,
  T extends true
    ? Record<'delete', References.DeleteResponseType>
    : References.DeleteResponseType
>;

export function useDeleteMutation<T extends boolean = false>(
  options?: MutationHookOptions<
    Record<'result', References.DeleteResponseType>,
    References.DeleteRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseDeleteMutationReturn<T> {
  const [getter, { data, ...rest }] = useMutation(
    Queries.DELETE_MUTATION,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            delete: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return [
      getter,
      { data: legacyFormatData, ...rest },
    ] as UseDeleteMutationReturn<T>;
  }
  return [
    getter,
    { data: data?.result, ...rest },
  ] as UseDeleteMutationReturn<T>;
}

type UsePublishMutationReturn<T extends boolean> = MutationTupleOverride<
  Record<'result', References.PublishResponseType>,
  References.PublishRequestType,
  T extends true
    ? Record<'publish', References.PublishResponseType>
    : References.PublishResponseType
>;

export function usePublishMutation<T extends boolean = false>(
  options?: MutationHookOptions<
    Record<'result', References.PublishResponseType>,
    References.PublishRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UsePublishMutationReturn<T> {
  const [getter, { data, ...rest }] = useMutation(
    Queries.PUBLISH_MUTATION,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            publish: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return [
      getter,
      { data: legacyFormatData, ...rest },
    ] as UsePublishMutationReturn<T>;
  }
  return [
    getter,
    { data: data?.result, ...rest },
  ] as UsePublishMutationReturn<T>;
}

type UseUnpublishMutationReturn<T extends boolean> = MutationTupleOverride<
  Record<'result', References.UnpublishResponseType>,
  References.UnpublishRequestType,
  T extends true
    ? Record<'unpublish', References.UnpublishResponseType>
    : References.UnpublishResponseType
>;

export function useUnpublishMutation<T extends boolean = false>(
  options?: MutationHookOptions<
    Record<'result', References.UnpublishResponseType>,
    References.UnpublishRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseUnpublishMutationReturn<T> {
  const [getter, { data, ...rest }] = useMutation(
    Queries.UNPUBLISH_MUTATION,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            unpublish: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return [
      getter,
      { data: legacyFormatData, ...rest },
    ] as UseUnpublishMutationReturn<T>;
  }
  return [
    getter,
    { data: data?.result, ...rest },
  ] as UseUnpublishMutationReturn<T>;
}

type UseGetPageViaIdQueryReturn<T extends boolean> = Omit<
  QueryResult<
    Record<'result', References.GetPageViaIdResponseType>,
    References.GetPageViaIdRequestType
  >,
  'data'
> & {
  data:
    | (T extends true
        ? Record<'getPageViaId', References.GetPageViaIdResponseType>
        : References.GetPageViaIdResponseType)
    | undefined;
};

export function useGetPageViaIdQuery<T extends boolean = false>(
  options?: QueryHookOptions<
    Record<'result', References.GetPageViaIdResponseType>,
    References.GetPageViaIdRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetPageViaIdQueryReturn<T> {
  const { data, ...rest } = useQuery(Queries.GET_PAGE_VIA_ID_QUERY, options);

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            getPageViaId: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return { data: legacyFormatData, ...rest } as UseGetPageViaIdQueryReturn<T>;
  }
  return { data: data?.result, ...rest } as UseGetPageViaIdQueryReturn<T>;
}

type UseGetPageViaIdLazyQueryReturn<T extends boolean> =
  LazyQueryResultTupleOverride<
    Record<'result', References.GetPageViaIdResponseType>,
    References.GetPageViaIdRequestType,
    T extends true
      ? Record<'getPageViaId', References.GetPageViaIdResponseType>
      : References.GetPageViaIdResponseType
  >;

export function useGetPageViaIdLazyQuery<T extends boolean = false>(
  options?: LazyQueryHookOptions<
    Record<'result', References.GetPageViaIdResponseType>,
    References.GetPageViaIdRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetPageViaIdLazyQueryReturn<T> {
  const [getter, { data, ...rest }] = useLazyQuery(
    Queries.GET_PAGE_VIA_ID_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            getPageViaId: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return [
      getter,
      { data: legacyFormatData, ...rest },
    ] as UseGetPageViaIdLazyQueryReturn<T>;
  }
  return [
    getter,
    { data: data?.result, ...rest },
  ] as UseGetPageViaIdLazyQueryReturn<T>;
}

type UseGetPageViaIdSuspenseQueryReturn<T extends boolean> = Omit<
  UseSuspenseQueryResult<
    Record<'result', References.GetPageViaIdResponseType>,
    References.GetPageViaIdRequestType
  >,
  'data'
> & {
  data: T extends true
    ? Record<'getPageViaId', References.GetPageViaIdResponseType>
    : References.GetPageViaIdResponseType;
};

export function useGetPageViaIdSuspenseQuery<T extends boolean = false>(
  options?: SuspenseQueryHookOptions<
    Record<'result', References.GetPageViaIdResponseType>,
    References.GetPageViaIdRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetPageViaIdSuspenseQueryReturn<T> {
  const { data, ...rest } = useSuspenseQuery(
    Queries.GET_PAGE_VIA_ID_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      options?.useLegacyFieldNameMode
        ? {
            getPageViaId: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseGetPageViaIdSuspenseQueryReturn<T>;
  }
  return {
    data: data?.result,
    ...rest,
  } as UseGetPageViaIdSuspenseQueryReturn<T>;
}

type UseGetPageViaOffsetQueryReturn<T extends boolean> = Omit<
  QueryResult<
    Record<'result', References.GetPageViaOffsetResponseType>,
    References.GetPageViaOffsetRequestType
  >,
  'data'
> & {
  data:
    | (T extends true
        ? Record<'getPageViaOffset', References.GetPageViaOffsetResponseType>
        : References.GetPageViaOffsetResponseType)
    | undefined;
};

export function useGetPageViaOffsetQuery<T extends boolean = false>(
  options?: QueryHookOptions<
    Record<'result', References.GetPageViaOffsetResponseType>,
    References.GetPageViaOffsetRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetPageViaOffsetQueryReturn<T> {
  const { data, ...rest } = useQuery(
    Queries.GET_PAGE_VIA_OFFSET_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            getPageViaOffset: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseGetPageViaOffsetQueryReturn<T>;
  }
  return { data: data?.result, ...rest } as UseGetPageViaOffsetQueryReturn<T>;
}

type UseGetPageViaOffsetLazyQueryReturn<T extends boolean> =
  LazyQueryResultTupleOverride<
    Record<'result', References.GetPageViaOffsetResponseType>,
    References.GetPageViaOffsetRequestType,
    T extends true
      ? Record<'getPageViaOffset', References.GetPageViaOffsetResponseType>
      : References.GetPageViaOffsetResponseType
  >;

export function useGetPageViaOffsetLazyQuery<T extends boolean = false>(
  options?: LazyQueryHookOptions<
    Record<'result', References.GetPageViaOffsetResponseType>,
    References.GetPageViaOffsetRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetPageViaOffsetLazyQueryReturn<T> {
  const [getter, { data, ...rest }] = useLazyQuery(
    Queries.GET_PAGE_VIA_OFFSET_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            getPageViaOffset: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return [
      getter,
      { data: legacyFormatData, ...rest },
    ] as UseGetPageViaOffsetLazyQueryReturn<T>;
  }
  return [
    getter,
    { data: data?.result, ...rest },
  ] as UseGetPageViaOffsetLazyQueryReturn<T>;
}

type UseGetPageViaOffsetSuspenseQueryReturn<T extends boolean> = Omit<
  UseSuspenseQueryResult<
    Record<'result', References.GetPageViaOffsetResponseType>,
    References.GetPageViaOffsetRequestType
  >,
  'data'
> & {
  data: T extends true
    ? Record<'getPageViaOffset', References.GetPageViaOffsetResponseType>
    : References.GetPageViaOffsetResponseType;
};

export function useGetPageViaOffsetSuspenseQuery<T extends boolean = false>(
  options?: SuspenseQueryHookOptions<
    Record<'result', References.GetPageViaOffsetResponseType>,
    References.GetPageViaOffsetRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetPageViaOffsetSuspenseQueryReturn<T> {
  const { data, ...rest } = useSuspenseQuery(
    Queries.GET_PAGE_VIA_OFFSET_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      options?.useLegacyFieldNameMode
        ? {
            getPageViaOffset: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseGetPageViaOffsetSuspenseQueryReturn<T>;
  }
  return {
    data: data?.result,
    ...rest,
  } as UseGetPageViaOffsetSuspenseQueryReturn<T>;
}

type UseToggleFavoriteMutationReturn<T extends boolean> = MutationTupleOverride<
  Record<'result', References.ToggleFavoriteResponseType>,
  References.ToggleFavoriteRequestType,
  T extends true
    ? Record<'toggleFavorite', References.ToggleFavoriteResponseType>
    : References.ToggleFavoriteResponseType
>;

export function useToggleFavoriteMutation<T extends boolean = false>(
  options?: MutationHookOptions<
    Record<'result', References.ToggleFavoriteResponseType>,
    References.ToggleFavoriteRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseToggleFavoriteMutationReturn<T> {
  const [getter, { data, ...rest }] = useMutation(
    Queries.TOGGLE_FAVORITE_MUTATION,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            toggleFavorite: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return [
      getter,
      { data: legacyFormatData, ...rest },
    ] as UseToggleFavoriteMutationReturn<T>;
  }
  return [
    getter,
    { data: data?.result, ...rest },
  ] as UseToggleFavoriteMutationReturn<T>;
}

type UseGetSuggestedPromptsQueryReturn<T extends boolean> = Omit<
  QueryResult<Record<'result', References.GetSuggestedPromptsResponseType>>,
  'data'
> & {
  data:
    | (T extends true
        ? Record<
            'getSuggestedPrompts',
            References.GetSuggestedPromptsResponseType
          >
        : References.GetSuggestedPromptsResponseType)
    | undefined;
};

export function useGetSuggestedPromptsQuery<T extends boolean = false>(
  options?: QueryHookOptions<
    Record<'result', References.GetSuggestedPromptsResponseType>
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetSuggestedPromptsQueryReturn<T> {
  const { data, ...rest } = useQuery(
    Queries.GET_SUGGESTED_PROMPTS_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            getSuggestedPrompts: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseGetSuggestedPromptsQueryReturn<T>;
  }
  return {
    data: data?.result,
    ...rest,
  } as UseGetSuggestedPromptsQueryReturn<T>;
}

type UseGetSuggestedPromptsLazyQueryReturn<T extends boolean> =
  LazyQueryResultTupleOverride<
    Record<'result', References.GetSuggestedPromptsResponseType>,
    {},
    T extends true
      ? Record<
          'getSuggestedPrompts',
          References.GetSuggestedPromptsResponseType
        >
      : References.GetSuggestedPromptsResponseType
  >;

export function useGetSuggestedPromptsLazyQuery<T extends boolean = false>(
  options?: LazyQueryHookOptions<
    Record<'result', References.GetSuggestedPromptsResponseType>
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetSuggestedPromptsLazyQueryReturn<T> {
  const [getter, { data, ...rest }] = useLazyQuery(
    Queries.GET_SUGGESTED_PROMPTS_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            getSuggestedPrompts: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return [
      getter,
      { data: legacyFormatData, ...rest },
    ] as UseGetSuggestedPromptsLazyQueryReturn<T>;
  }
  return [
    getter,
    { data: data?.result, ...rest },
  ] as UseGetSuggestedPromptsLazyQueryReturn<T>;
}

type UseGetSuggestedPromptsSuspenseQueryReturn<T extends boolean> = Omit<
  UseSuspenseQueryResult<
    Record<'result', References.GetSuggestedPromptsResponseType>
  >,
  'data'
> & {
  data: T extends true
    ? Record<'getSuggestedPrompts', References.GetSuggestedPromptsResponseType>
    : References.GetSuggestedPromptsResponseType;
};

export function useGetSuggestedPromptsSuspenseQuery<T extends boolean = false>(
  options?: SuspenseQueryHookOptions<
    Record<'result', References.GetSuggestedPromptsResponseType>
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetSuggestedPromptsSuspenseQueryReturn<T> {
  const { data, ...rest } = useSuspenseQuery(
    Queries.GET_SUGGESTED_PROMPTS_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      options?.useLegacyFieldNameMode
        ? {
            getSuggestedPrompts: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseGetSuggestedPromptsSuspenseQueryReturn<T>;
  }
  return {
    data: data?.result,
    ...rest,
  } as UseGetSuggestedPromptsSuspenseQueryReturn<T>;
}
